import type { DateTime } from 'luxon'

import type { BidUpdate } from '@/features/bidding/types/bidUpdate'

/**
 * BidUpdates have two possible timestamps: offered and accepted.
 * Accepted takes precedence over offered if it exists, otherwise offered time is returned.
 * This applies to both getting the "time" of a bid update and sorting bid updates by "time".
 */

export const getBidUpdateTime = (bidUpdate: BidUpdate): DateTime | undefined =>
  bidUpdate.acceptedTime ?? bidUpdate.offeredTime

export const sortBidUpdatesByTime = (bidUpdates: BidUpdate[]): BidUpdate[] =>
  bidUpdates.toSorted(
    (bidUpdate1, bidUpdate2) =>
      (getBidUpdateTime(bidUpdate1)?.valueOf() ?? 0) - (getBidUpdateTime(bidUpdate2)?.valueOf() ?? 0),
  )

export const getLatestBidUpdate = (bidUpdates: BidUpdate[]): BidUpdate =>
  sortBidUpdatesByTime(bidUpdates)[bidUpdates.length - 1]
